import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Book from "@/pages/Book";
import Admin from "@/pages/Admin";
import Intake from "@/pages/Intake";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import WellbeingLauncher from "@/components/WellbeingLauncher";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/book" element={<Book />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/intake/:token" element={<Intake />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <WellbeingLauncher />
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FAF8F5",
            color: "#1A3636",
            border: "1px solid #D2C5A9",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
